export const getPageKeywords = (path: string, articleSlug?: string): string => {
  const baseKeywords = 'image converter, image format, convert images, webp, png, jpg, jpeg, avif, gif, svg';
  
  const pathKeywords: Record<string, string> = {
    '/': 'free image converter, online image conversion, batch image converter',
    '/articles': 'image format guides, image optimization, web development',
    '/plugins': 'figma plugin, design tools, image export',
    '/troubleshooting': 'image conversion help, troubleshooting guide',
    '/release-notes': 'updates, new features, changelog',
    '/legal': 'privacy policy, terms of service, legal',
    '/cookie-policy': 'cookies, privacy, data protection',
    '/faq': 'frequently asked questions, help, image converter faq, common questions'
  };
  
  // Article-specific keywords
  const articleKeywords: Record<string, string> = {
    'webp-the-modern-web-format': 'webp format, modern image format, web optimization',
    'choosing-right-image-format': 'image format comparison, best image format, format selection',
    'png-the-lossless-web-standard': 'png format, lossless compression, transparent images',
    'jpg-the-universal-image-format': 'jpeg format, lossy compression, photography',
    'avif-the-next-generation-format': 'avif format, next generation, advanced compression',
    'svg-the-scalable-vector-graphics-format': 'svg format, vector graphics, scalable images',
    'gif-the-animated-format-that-defined-the-early-web': 'gif format, animated images, web history',
    'optimizing-images-for-mobile-devices': 'mobile optimization, responsive images, performance'
  };
  
  let keywords = baseKeywords;
  
  // Add path-specific keywords
  if (pathKeywords[path]) {
    keywords += `, ${pathKeywords[path]}`;
  }
  
  // Add article-specific keywords
  if (articleSlug && articleKeywords[articleSlug]) {
    keywords += `, ${articleKeywords[articleSlug]}`;
  }
  
  return keywords;
};

export const formatDateForSeo = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return date.toISOString();
  } catch (error) {
    // If date parsing fails, return current date
    return new Date().toISOString();
  }
};